import { descriviControllo, descriviMossa, nomeFlusso } from './Functions'
import { t } from './testi'

/** Il corpo di uno scenario aperto: cosa fa, i passaggi e cosa viene controllato. */
const CorpoScenario = ({ scenario }) => (
  <div className="ae-voce__corpo">
    {scenario.situazione ? <p className="ae-situazione">{scenario.situazione}</p> : null}
    <p className="ae-muto">{scenario.descrizione}</p>
    <p className="ae-muto">{scenario.origine}</p>
    <p className="ae-voce__titolo">{t.aePassaggi}</p>
    {scenario.tipo === 'conversazione' ? (
      <>
        <ol className="ae-passaggi">
          {(scenario.messaggi ?? []).map((messaggio, i) => (
            <li key={i}>{messaggio}</li>
          ))}
        </ol>
        <p className="ae-voce__titolo">{t.aeControlli}</p>
        <ul className="ae-controlli">
          {(scenario.controlli ?? []).map((controllo, i) => (
            <li key={i}>{descriviControllo(controllo)}</li>
          ))}
        </ul>
      </>
    ) : (
      <>
        <ol className="ae-passaggi">
          {(scenario.storia ?? []).map((battuta, i) => (
            <li key={i}>
              <span className="ae-muto">{battuta.da}: </span>
              {battuta.testo}
            </li>
          ))}
        </ol>
        {scenario.copione?.length ? (
          <>
            <p className="ae-voce__titolo">{t.aeCopione}</p>
            <ol className="ae-controlli">
              {scenario.copione.map((mossa, i) => (
                <li key={i}>
                  <code>{descriviMossa(mossa)}</code>
                </li>
              ))}
            </ol>
          </>
        ) : null}
        <p className="ae-muto">
          {t.aeAttesa}: {scenario.attesa}
          {scenario.vietata ? ` · ${t.aeVietata}: ${scenario.vietata}` : ''}
          {scenario.rifiutoAtteso ? ` · ${t.aeRifiutoAtteso}: ${scenario.rifiutoAtteso}` : ''}
        </p>
      </>
    )}
    <p className="ae-muto">
      {t.aeSoglia} {Math.round((scenario.soglia ?? 0) * 100)}% · {scenario.lingua} ·{' '}
      {scenario.canale}
    </p>
  </div>
)

/** Il tooltip della riga: cosa fa lo scenario, e dove e con cosa gira. */
const titoloScenario = (scenario) =>
  [
    scenario.situazione || scenario.descrizione,
    scenario.flussi?.length ? scenario.flussi.map((f) => nomeFlusso(f)).join(' / ') : null,
    scenario.capability?.length ? scenario.capability.join(', ') : null
  ]
    .filter(Boolean)
    .join(' · ')

/**
 * Uno scenario del form: si seleziona con la casella e si apre per leggere cosa fa.
 * Il testo (situazione, messaggi, controlli) resta quello del JSON.
 * @param {Object} props - Proprietà
 * @param {Object} props.scenario - Lo scenario del catalogo
 * @param {boolean} props.scelto - Se è selezionato
 * @param {(acceso: boolean) => void} props.onChange - Seleziona o deseleziona
 * @param {number[]|null} props.giraSu - Gli environment su cui gira (null: non ancora scelti)
 */
export const VoceScenario = ({ scenario, scelto, onChange, giraSu }) => (
  <div className={`ae-voce ${scelto ? 'is-scelta' : ''}`}>
    <input
      type="checkbox"
      className="ae-voce__scelta"
      checked={scelto}
      aria-label={scenario.id}
      onChange={(e) => onChange(e.target.checked)}
    />
    <details className="ae-voce__dettaglio" title={titoloScenario(scenario)}>
      <summary>
        <strong>{scenario.id}</strong>
        <span className="ae-voce__tag">
          <span className="nbadge">{scenario.tipo}</span>
          <span className="nbadge">×{scenario.ripetizioni}</span>
          {giraSu ? (
            giraSu.length ? (
              giraSu.map((id) => (
                <span key={id} className="nbadge nbadge--info">
                  env {id}
                </span>
              ))
            ) : (
              <span className="nbadge nbadge--warn">{t.aeNonGiraQui}</span>
            )
          ) : null}
        </span>
      </summary>
      <CorpoScenario scenario={scenario} />
    </details>
  </div>
)
